export const clearTextSelection = (): void => {
  if (window.getSelection) {
    const selection = window.getSelection()
    if (selection !== null && selection.toString()) {
      selection.removeAllRanges()
    }
  }
}
